import React from 'react';

const sections = [
  {
    heading: '1. Overview',
    body: [
      `This page explains O!ng Lab's refund policy for paid products.`,
      `The rules depend on the product type and whether you have started using the product. Please read this page before you buy.`,
      `If you have a question, contact us at contact@oinglab-korean.com.`,
    ],
  },
  {
    heading: '2. Product types',
    body: [
      `· Offline workshop — an in-person event in Korea, on a fixed date`,
      `· Online live session — a real-time online session, on a fixed date and time`,
      `· Video course — recorded lessons you watch inside O!ng`,
      `· Downloadable material — files (such as PDFs) you can save to your device`,
      `· View-only material — content you can read inside O!ng, but cannot download`,
      `· Bundle — two or more products sold together`,
    ],
  },
  {
    heading: '3. General rule',
    body: [
      `For all product types, refunds may be available before you start using the product.`,
      `After use begins — such as viewing, downloading, attending, or accessing the content — refunds may be limited.`,
      `The specific rules depend on the product type. See Section 4.`,
    ],
  },
  {
    heading: '4. Refund rules by product type',
    body: [
      `4-1. Offline workshop`,
      `· 7 or more days before the event → Full refund`,
      `· 3–6 days before the event → 50% refund`,
      `· 2 days or less before the event → Refunds may be limited`,
      `· No-show (absent without notice) → Refunds may be limited`,
      `If O!ng cancels: All participants receive a full refund.`,
      `If O!ng reschedules: You can accept the new date, or receive a full refund.`,
      `Date change: You can move your booking to another available date of the same workshop, up to 7 days before the event. Contact us at contact@oinglab-korean.com to request a change.`,
      ``,
      `4-2. Online live session`,
      `· Before your session link is sent → Full refund`,
      `· After your session link is sent → Refunds may be limited`,
      `· No-show (absent without notice) → Refunds may be limited`,
      `Session times are shown in KST (Korea Standard Time, UTC+9). Please check your local time before booking.`,
      `If O!ng cancels: Full refund.`,
      `If O!ng reschedules: Accept the new time, or receive a full refund.`,
      ``,
      `4-3. Video course`,
      `· Not started watching + within 7 days of purchase → Full refund may be available`,
      `· After viewing starts → Refunds may be limited`,
      `"Viewing starts" means you have opened or played any part of the course.`,
      `Access starts immediately after payment, unless the product page says otherwise. The access period is shown on the product page (for example: 90 days from purchase, or unlimited).`,
      ``,
      `4-4. Downloadable material`,
      `· Not downloaded + within 7 days of purchase → Full refund may be available`,
      `· After download is complete → Refunds may be limited`,
      `Once a file is downloaded, it can be saved or copied to your device. For this reason, refunds may be limited after download.`,
      ``,
      `4-5. View-only material`,
      `· Not viewed + within 7 days of purchase → Full refund may be available`,
      `· After viewing begins → Refunds may be limited`,
      `View-only materials are available inside O!ng only. They cannot be downloaded.`,
      ``,
      `4-6. Bundle`,
      `· Before any part is used → Full refund may be available within the eligible period`,
      `· After one or more parts are used → Refunds may apply to unused portions only`,
      `Refund amounts depend on which parts of the bundle have been used. Used portions may not be refunded. Bundle discounts may affect the refund calculation.`,
      `Bundle refunds are reviewed by our support team. They are not processed automatically. Contact us to request a bundle refund.`,
    ],
  },
  {
    heading: '5. Exceptions — when we always review your case',
    body: [
      `Even after use has started, or after a cancellation deadline, we will review your case in these situations:`,
      `· Duplicate payment — you were charged more than once for the same product`,
      `· Technical error on O!ng's side that prevented you from using the product`,
      `· O!ng's fault — O!ng cancelled or made a significant change to the product`,
      `· Product mismatch — the product was materially different from what was described`,
      `· Applicable law — a refund is required by law`,
      `· Payment provider requirement — a refund is required by payment provider processing`,
      `In these cases, please contact us with your details. We will review your situation carefully.`,
    ],
  },
  {
    heading: '6. How refunds are processed',
    body: [
      `Method: Refunds are sent to your original payment method — the card or PayPal account you used to pay.`,
      `Timing: We aim to review refund requests within 3 business days. After approval, the time it takes to appear in your account depends on your card issuer, PayPal, or payment provider.`,
      `Currency: Refunds are processed in the same currency you paid.`,
      `· Korean card (KRW) → KRW`,
      `· Overseas card (USD) → USD`,
      `· PayPal (USD) → USD`,
    ],
  },
  {
    heading: '7. Currency and payment provider notes',
    body: [
      `If you paid in USD:`,
      `· Exchange rate changes between your payment date and the refund date may affect the amount you see in your account.`,
      `· Your card issuer or bank may apply their own conversion fees or exchange rates.`,
      `· PayPal fees and policies may also affect the final amount you receive.`,
      `· These differences are caused by your card issuer, PayPal, or currency conversion, and are outside O!ng's direct control.`,
      ``,
      `If you paid with PayPal:`,
      `· PayPal transaction fees may not be returned if a payment is cancelled.`,
    ],
  },
  {
    heading: '8. How to request a refund',
    body: [
      `Option 1 — From your O!ng account:`,
      `Go to My Page → Payments → View invoice → Request a refund.`,
      `Select the reason and submit your request.`,
      ``,
      `Option 2 — Contact support:`,
      `Email: contact@oinglab-korean.com`,
      `Please include the following:`,
      `· Your name`,
      `· Email address used for the purchase`,
      `· Product name`,
      `· Purchase date`,
      `· Payment method`,
      `· Reason for your request`,
      `· Screenshots or additional details, if relevant`,
      `We will reply within 3 business days.`,
    ],
  },
  {
    heading: '9. Contact',
    body: [
      `Questions about refunds or cancellations?`,
      `Email us: contact@oinglab-korean.com`,
      `We're here to help.`,
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: 'Refund Policy',
  lastUpdated: 'June 11, 2026',
  effectiveDate: '2026-06-11',
  sections,
};
